import type { SortingState } from '@tanstack/react-table'
import { useCallback, useMemo, useState } from 'react'

const PUBLISHER_REQUEST_LIST_SORT_BY_FIELD: Record<string, string> = {
  'clientRequest.cartItemTypeId': 'client_request.cart_item_type_id',
  'clientRequest.licenseeName': 'client_request.licensee_name',
  'clientRequest.publicationAuthorArrangerEditor':
    'client_request.publication_author_arranger_editor',
  'clientRequest.publicationType': 'client_request.publication_type',
  type: 'type',
  'clientRequest.createdAt': 'created_at',
}

type CrudListSorter = { field: string; order: 'asc' | 'desc' }

type UsePublisherRequestsListSortingParams = {
  resetToFirstPage: () => void
}

export const usePublisherRequestsListSorting = ({
  resetToFirstPage,
}: UsePublisherRequestsListSortingParams) => {
  const [sorting, setSorting] = useState<SortingState>([{ id: 'clientRequest.createdAt', desc: true }])

  const handleSortingChange = useCallback(
    (updater: SortingState | ((old: SortingState) => SortingState)) => {
      setSorting(prev => {
        const next = typeof updater === 'function' ? updater(prev) : updater
        return next
      })
      resetToFirstPage()
    },
    [resetToFirstPage],
  )

  const listSorters: CrudListSorter[] = useMemo(() => {
    const row = sorting[0]
    if (!row) {
      return []
    }
    const field = PUBLISHER_REQUEST_LIST_SORT_BY_FIELD[row.id]
    if (!field) {
      return []
    }
    return [{ field, order: row.desc ? 'desc' : 'asc' }]
  }, [sorting])

  return {
    sorting,
    listSorters,
    handleSortingChange,
  }
}
